export const SETAPPWEB = 'SETAPPWEB';
export const SETMENU = 'SETMENU';
export const SETMATCH = 'SETMATCH';
export const SETGAMEID = 'SETGAMEID';
export const SETMENUNAME = 'SETMENUNAME';


// WEBPACK FOOTER //
// ./src/store/types.js